import React, { useEffect, useState } from 'react';
import { BlogPosts } from 'src/components/Blog/BlogPosts';
import { CustomPagination } from 'src/components/CustomPagination/CustomPagination';
import { useQuery } from '@apollo/client';
import getTotalCountOfBlogPosts from 'src/queries/getTotalCountOfBlogPosts.graphql';
import Bugsnag from '@bugsnag/js';
import { useSearch } from 'src/hooks/router-hooks';

const NUMBER_OF_RESULTS_PER_PAGE = 8;

export const BlogPostsContainer: React.FC = () => {
    const { error, data, loading } = useQuery(getTotalCountOfBlogPosts);
    const search = useSearch();
    const [page, setPage] = useState(1);

    useEffect(() => {
        const pageFromLink = Number(new URLSearchParams(search).get('page'));
        if (pageFromLink) {
            setPage(pageFromLink);
        } else {
            setPage(1);
        }
    }, [search]);

    if (error) {
        Bugsnag.notify(`Error: ${error}`);
    }

    if (loading) return null;

    if (!data || data.blogPosts.total_count === 0) return <p>There are no posts.</p>;

    return (
        <div>
            <BlogPosts page={page} numberOfResultsPerPage={NUMBER_OF_RESULTS_PER_PAGE} />
            <CustomPagination
                numberOfResults={data.blogPosts.total_count}
                currentPage={page}
                numberOfResultsPerPage={NUMBER_OF_RESULTS_PER_PAGE}
                host="blog"
            />
        </div>
    );
};
